
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Date Icon","width":"24","height":"24","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABf0lEQVRIibWUvUoDQRSFv9WoYC0qSBr1KYymEGzsxSD4Amphp5WptbKJ2tgpQV8hgqDRF1EE0UYQRVKsXDkrwyTZ3UnIgeXs3p85OzP33qjRaOChCcTAku9IQdecQoecUsDCmTkFKSeIPH/cntKGtJzI30EReND7dK5/z8jxBc6ANWAYOM8pkJrjC6wCLzkXzpUzFLhYMAYu4B6RXw394L+SBrWDz0ELzALX/QosAnXgGfgR12V/A9Z7FbB7qwH3QAWYAUbFFdnNP9KrwCmwBXwDVWAeGBNXZTf/iQXbNE1uPE8VlTQ5v4AV4FH22MlfAGxEj9txhe5gW3zoLO7D7Eey7YQKLIsvM+IuxOVQgSnxUwdf7DRY4p8IFXgVFz175DyoogzvoQK34o2MuE3xXahATbyvaukEs+8l8a5AnPJ8AJMqUROxErwBDoA5NZqxfZvd/BbXdPsgC1fqVOvQYzVTN1iT7QIta/vQMd1SP9jcMS5btdiF2pknf/4XCfwCxlVVsw/wytgAAAAASUVORK5CYII="}})])
          )
        }
      }
    